export const WRITER_CONVERSATIONS_URL = "/api/visi/conversations";

export const ALL_PAGES_SCOPE = "all";
